// extracted by mini-css-extract-plugin
module.exports = {"tagsInformation":"TagsInformation_tagsInformation__3_mfR","chips":"TagsInformation_chips__2rATG"};